const inlineSelector = "[data-location-cards].location-cards--inline";
const descriptionToggleSelector = "[data-location-card-description-toggle]";

const initCardGrid = (section) => {
  const track = section.querySelector("[data-location-cards-track]");
  const controls = section.querySelector(".location-cards__controls");
  const previous = section.querySelector("[data-location-cards-previous]");
  const next = section.querySelector("[data-location-cards-next]");
  if (!track || !controls || !previous || !next) return;

  const updateButtons = () => {
    const maximum = track.scrollWidth - track.clientWidth;
    previous.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= maximum - 1;
  };

  const updateLayout = () => {
    const overflowing = track.scrollWidth > track.clientWidth + 1;
    section.classList.toggle("location-cards--has-overflow", overflowing);
    section.classList.add("location-cards--is-ready");
    controls.hidden = !overflowing;
    if (overflowing) {
      track.tabIndex = 0;
      track.setAttribute("role", "group");
      track.setAttribute("aria-label", controls.getAttribute("aria-label"));
    } else {
      track.removeAttribute("tabindex");
      track.removeAttribute("role");
      track.removeAttribute("aria-label");
    }
    updateButtons();
  };

  const scrollTo = (left) => track.scrollTo({
    left,
    behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
  });

  const move = (direction) => {
    // Measure each card so mixed card sizes and resizing keep the same snap points.
    const start = track.getBoundingClientRect().left + track.clientLeft;
    const positions = Array.from(track.children).map(card => card.getBoundingClientRect().left - start + track.scrollLeft);
    const target = direction > 0
      ? positions.find(position => position > track.scrollLeft + 2) ?? track.scrollWidth
      : positions.findLast(position => position < track.scrollLeft - 2) ?? 0;
    scrollTo(target);
  };

  previous.addEventListener("click", () => move(-1));
  next.addEventListener("click", () => move(1));
  track.addEventListener("scroll", updateButtons, { passive: true });
  track.addEventListener("keydown", event => {
    if (event.target !== track) return;
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.preventDefault();
      move(event.key === "ArrowRight" ? 1 : -1);
    } else if (event.key === "Home" || event.key === "End") {
      event.preventDefault();
      scrollTo(event.key === "Home" ? 0 : track.scrollWidth);
    }
  });
  const observer = new ResizeObserver(updateLayout);
  observer.observe(track);
  Array.from(track.children).forEach(card => observer.observe(card));
  updateLayout();
};

document.querySelectorAll(inlineSelector).forEach(initCardGrid);

document.querySelectorAll(descriptionToggleSelector).forEach((toggle) => {
  toggle.addEventListener("click", () => {
    const card = toggle.closest(".location-card");

    if (!card) {
      return;
    }

    const isExpanded = card.classList.toggle("location-card--description-expanded");

    toggle.setAttribute("aria-expanded", String(isExpanded));
    toggle.textContent = isExpanded ? toggle.dataset.showLess : toggle.dataset.showMore;
  });
});
